import React, { useCallback, useRef } from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import MobileHeaderOnly from "components/headers/light.js";
import CateringComponent from "salad/CateringComponent";
import GrainFooter from "salad/GrainFooter";
import CateringQuoteForm from "salad/CateringQuoteForm";

export default () => {
    const formRef = useRef(null);

    const handleQuoteClick = useCallback(() => {
        if (formRef.current) {
            formRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }, []);

    return (
        <div style={{ backgroundColor: "#FFFBDC", minHeight: "100vh" }}>
            <MobileHeaderOnly />
            <AnimationRevealPage>
                <CateringComponent onQuoteClick={handleQuoteClick} />
                <CateringQuoteForm ref={formRef} />
                <GrainFooter />
            </AnimationRevealPage>
        </div>
    );
};
